export enum ROLES {
    ADMIN = "admin",
    CHAUFFEUR = "chauffeur",
    CLIENT = "client",
    FOURNISSEUR = "fournisseur",
}